import React from 'react'

export const AboutView = () => (
  <div className="pageHeader">
    <h1>About</h1>
    <div className="about-content">
    I'm a passionate engineer seeking for rigor and elegance in order to get best results.

I'm always wanting to learn, specially anything related to functional programming, compiler engineering and runtime systems.

I'm also a contributor of a functional programming named Frege.

My expertise includes solid skills on Scala, Haskell, Java and their associated ecosystems.
    </div>
  </div>
)

export default AboutView



// WEBPACK FOOTER //
// ./src/routes/About/components/AboutView.js